import { render, staticRenderFns } from "./Allreferrals.vue?vue&type=template&id=8813fba2&scoped=true&"
import script from "./Allreferrals.vue?vue&type=script&lang=js&"
export * from "./Allreferrals.vue?vue&type=script&lang=js&"
import style0 from "./Allreferrals.vue?vue&type=style&index=0&id=8813fba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8813fba2",
  null
  
)

export default component.exports